class FormatMask {
  setPhoneFormatMask(phoneToFormat) {
    if (phoneToFormat === undefined || phoneToFormat === null || phoneToFormat === "") {
      return phoneToFormat ?? "";
    }

    const raw = String(phoneToFormat);
    if (raw.length < 12) {
      return raw;
    }

    const number = raw.replace(/\D/g, "");

    if (number.length <= 12) {
      const phoneNumberFormatted = number.match(/^(\d{2})(\d{2})(\d{4})(\d{4})$/);
      if (!phoneNumberFormatted) {
        return raw;
      }
      return (
        "+" +
        phoneNumberFormatted[1] +
        " (" +
        phoneNumberFormatted[2] +
        ") " +
        phoneNumberFormatted[3] +
        "-" +
        phoneNumberFormatted[4]
      );
    } else if (number.length === 13) {
      const phoneNumberFormatted = number.match(/^(\d{2})(\d{2})(\d{5})(\d{4})$/);
      if (!phoneNumberFormatted) {
        return raw;
      }
      return (
        "+" +
        phoneNumberFormatted[1] +
        " (" +
        phoneNumberFormatted[2] +
        ") " +
        phoneNumberFormatted[3] +
        "-" +
        phoneNumberFormatted[4]
      );
    } else {
      return raw;
    }
  }

  removeMask(number) {
    const filterNumber = number.replace(/\D/g, "");
    return filterNumber;
  }

  maskPhonePattern(phoneNumber) {
    if (!phoneNumber || String(phoneNumber).length < 13) {
      return "🇧🇷 (99) 9999 9999";
    }
    return "🇧🇷 (99) 99999 9999";
  }
}

export { FormatMask };